/* eslint-disable */
import Vue from 'vue'
import VueRouter from 'vue-router'
import { constantRouterMap } from '@/config/router.config'
Vue.use(VueRouter)


const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes:constantRouterMap
})

export default router
